<template>
  <div class="meet-contacts-list-root d-flex flex-column">
    <div class="meet-contacts-table-scroll">
      <v-data-table
                :headers="headers"
                :items="value"
                :sort-by="['agency', 'name']"
                :sort-desc="[false]"
                :disable-pagination="true"
                :hide-default-footer="true"
                class="elevation-0 tbl table"
                no-data-text="Aucun contact."
            >
              <template #header.agencyName="{ header }">
                <span class="pl-4">{{ header.text }}</span>
              </template>
              <template #item.agencyName="{ value }">
                <span class="pl-4">{{ value }}</span>
              </template>
              <template #item.creationDate="{ value }">
                <span class="caption grey--text">{{ _formatDate(_parseDateISO(value), datePatternConfig.fr.time) }}</span>
              </template>
              <template #item.contactCount="{ item }">
                <span class="">{{ contactsMap[item.id].length }}</span>
              </template>
              <template v-if="!isLocked" #item.actions="{item}">
                <v-row v-if="!readonly " no-gutters justify="end" class="pr-4">
                  <v-icon v-if="item.agencyId " small class="mr-4" @click="editAgency(item)">mdi-home-outline</v-icon>
                  <v-icon small class="mr-2" @click="editContact(item)">edit</v-icon>
                  <v-icon small @click="deleteContact(item)">delete</v-icon>
                </v-row>
              </template>
            </v-data-table>
    </div>

    <!-- EDIT DIALOG -->
    <smart-dialog :title="edition.title" v-model="edition.dialog" :width="632">
      <v-container v-if="edition.contact">
        <v-form v-if="edition.context !== 'DELETE'" v-on:submit.prevent="save" ref="form" v-model="edition.valid">
          <!-- firstame name email - Row -->
          <v-row dense class="px-4 pt-4">
            <v-col cols="6">
              <v-text-field dense  v-model="edition.contact.firstname" label="Prénom" />
            </v-col>
            <v-col cols="6">
              <v-text-field dense  v-model="edition.contact.lastname" label="Nom" />
            </v-col>
            <v-col cols="12">
              <v-text-field dense  v-model="edition.contact.email" label="email" :rules="rules.emailOrEmpty()"/>
            </v-col>

            <v-col cols="12" v-if="!hasAtLeastOneContactField">
              <p class="error--text text-caption">
                Renseignez au moins un des champs : prénom, nom ou email.
              </p>
            </v-col>
          </v-row>

          <!-- Agence - WildAgent  (editable)-->
          <v-divider v-if="!edition.contact.agencyId" class="my-4"/>
          <v-row v-if="!edition.contact.agencyId" dense class="px-4 pt-2">
            <v-col cols="6">
            <div class="d-flex items-center">
              <p class="font-weight-medium grey--text">
                <span class="text--darken-2">Nom de l'agence</span>
                <span class="caption font-weight-regular text--lighten-2 ml-1">saisie rapide</span>
              </p>
            </div>
              <v-text-field dense v-model="edition.contact.agencyName" />
            </v-col>
            <v-col cols="6" />
          </v-row>

          <!-- Agence - Row  (readonly)-->
          <v-divider v-if="edition.contact.agencyId && edition.contact.agencyName" class="my-4"/>
          <v-row v-if="edition.contact.agencyId && edition.contact.agencyName" dense class="px-4 pt-4">
            <v-col cols="6">
              <v-text-field dense readonly v-model="edition.contact.agencyName" label="Agence" />
            </v-col>
            <v-col cols="6" />

            <v-col cols="2" class="d-flex align-center justify-center">
              <v-icon color="blue darken-2" size="60">mdi-information-slab-box</v-icon>
            </v-col>
            <v-col cols="10">
              <p class="caption lighten-1">
                La modification de l'agence associée au contact n'est pas possible directement.
                Pour ce faire, veuillez supprimer le contact puis le créer à nouveau en recherchant l'agence désirée.
              </p>
            </v-col>
          </v-row>
        </v-form>
        <div v-else>
          <p><b>Attention</b>, la suppression d'un contact est <b>définitive.</b></p>
          <p>Celui-ci va être retiré de la session de workshop actuelle.</p>
          <div class="mt-2" v-if="edition.contact.agencyId && edition.contact.agentId" >
            <p>Ce contact est un agent de l'agence {{edition.contact.agencyName}}.</p>
            <p>Vous pouvez le supprimer en toute sécurité, sa fiche agent restera inchangée.</p>
          </div>
        </div>
      </v-container>
      <template #actions>
        <smart-btn v-if="edition.context === 'EDIT'" :disabled="!edition.valid || !hasAtLeastOneContactField" primary @click.native="edition.btnFn()">
          Enregistrer
        </smart-btn>
        <smart-btn v-else primary @click.native="edition.btnFn()">
          Supprimer
        </smart-btn>
      </template>
    </smart-dialog>
  </div>
</template>

<script>
import FormMixin from "@/components/mixins/FormMixin";
import {post} from "@/utils/api";
import {EventBus} from "@/components/commons/event-bus";

export default {
  name: "MeetContactsList",
  components: {},
  emits:['contacts-updated', 'edit-agency'],
  mixins: [FormMixin],
  props: {
    value: { type: Array, default: () => [] },
    readonly: { type: Boolean, default: false },
    isLocked: { type: Boolean, default: false }
  },
  data: () => ({
    edition: {
      dialog: false,
      title: "",
      contact: null,
      valid: true,
      disabled: false,
      context: "Edit",
      btnFn:null,
    },
  }),
  created() {
  },
  watch: {},
  computed: {
    hasAtLeastOneContactField() {
      const c = this.edition.contact || {}
      const firstname = String(c.firstname ?? "").trim()
      const lastname = String(c.lastname ?? "").trim()
      const email = String(c.email ?? "").trim()

      return firstname !== "" || lastname !== "" || email !== ""
    },
    headers() {
      const baseHeaders = [
        { text: "Agence", value: "agencyName", align: "left"},
        { text: "Prénom", value: "firstname", align: "left"},
        { text:"Nom", value:"lastname", align: "left"},
        { text:"Email", value:"email", align: "left"},
      ]

      if (!this.isLocked) {
        baseHeaders.push({ text: "Actions", value: "actions", align: "right" })
      }

      return baseHeaders
    },
  },
  methods: {
    editAgency(contact) {
      if (!contact.agencyId || this.isLocked) { return }
      this.$emit('edit-agency', contact.agencyId)
    },
    editContact(contact) {
      this.edition.title = "Modifier le contact"
      this.edition.contact = { ...contact }
      this.edition.dialog = true
      this.edition.context = 'EDIT'
      this.edition.btnFn = () => this.save()
    },
    deleteContact(contact) {
      this.edition.title = "Suppression du contact"
      this.edition.contact = { ...contact };
      this.edition.dialog = true;
      this.edition.context='DELETE'
      this.edition.btnFn = () => this.remove(contact)
    },
    save() {
      if (!this.$refs.form.validate() || !this.hasAtLeastOneContactField || this.isLocked) return
      const payload = {
        ...this.edition.contact,
        firstname: String(this.edition.contact.firstname ?? "").trim() || null,
        lastname: String(this.edition.contact.lastname ?? "").trim() || null,
        email: String(this.edition.contact.email ?? "").trim() || null,
        agencyName: String(this.edition.contact.agencyName ?? "").trim() || null,
      }
      const url = `/api/workshop/${payload.workshopId}/contact/${payload.meetId}/${payload.id}`

      post(url, payload).res(() => {
        this.$emit("contacts-updated")
        this.edition.dialog = false;
        EventBus.$emit("toaster-msg", "Contact enregistré");
      })

    },
    remove(contact) {
      if (this.isLocked) { return }
      const payload = [contact.id] // [N] Create + Delete WorkshopContact routes required List
      return post(`/api/workshop/${contact.workshopId}/contact/${contact.meetId}/delete`, payload)
          .badRequest((err) => {
            EventBus.$emit("toaster-msg", err.toString());
          })
          .res(() => {
            EventBus.$emit("toaster-msg", "Suppression du contact confirmée");
            this.$emit("contacts-updated")
            this.edition.dialog = false
          });
    },
  }
}
</script>


<style scoped>
.meet-contacts-list-root {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.meet-contacts-table-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

.table {
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 4px;
}
</style>